import React, { useEffect,useState } from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import Swal from 'sweetalert2';
import CustomTable from '../../helpers/custom-table'
import { catchError } from '../../helpers/catch-error'
import { NavLink } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const Archived = () => {
  const navigate = useNavigate();
  const [data, setData] = React.useState(null);
   const [woSearch, setWoSearch] = useState(null);
  var columns = React.useMemo(
    () => [
      {
        accessorFn: row => <a
          className={row.is_updated == 1 ? "fw-bold text-shadow text-danger" : ""}
          href={"/admin/work-order/" + row.work_order_id} >{row.work_order_no}</a>,
        id: "work_order_id",
        cell: info => info.getValue(),
        header: () => "ID",
        footer: props => props.column.id,
        enableColumnFilter: false,
      },
      {
        accessorFn: row => row.wo_creation_date,
        id: "wo_creation_date",
        cell: ({ getValue }) => (
          <span>
            <ul className="table-ul">
              {(getValue().split("_")).map((p, index) => (
                <li key={index}>{p}</li>
              ))}
            </ul>
          </span>
        ),
        header: () => "Date",
        footer: props => props.column.id
      },
      {
        accessorFn: row => row.copy_date + "_" + row.copy_date_set_by,
        id: "wo_copy_date",
        cell: ({ getValue }) => (
          <span>
            <ul className="table-ul">
              {(getValue().split("_")).map((p, index) => (
                <li key={index}>{p}</li>
              ))}
            </ul>
          </span>
        ),
        header: () => "Copy Date/By",
        footer: props => props.column.id
      },
      {
        accessorFn: row => row.patient_last_name + " " + row.patient_first_name,
        id: "lastName",
        cell: info => info.getValue(),
        header: () => "Patient",
        footer: props => props.column.id
      },
      {
        accessorKey: "client_company_name",
        header: "Client",
        footer: props => props.column.id
      },
      {
        accessorKey: "facility_name",
        header: "Facility",
        footer: props => props.column.id
      },
      {
        accessorFn: row => <>
          <a onClick={() => copyWorkOrder(row.work_order_id)} href="javascript:void(0)" className="btn btn-link ">Copy</a>

          <a onClick={() => reOpenWorkOrder(row.work_order_id)} href="javascript:void(0)" className="btn btn-link " >Re-open</a><br />

        </>,
        id: "actions",
        cell: info => info.getValue(),
        header: () => "ACTIONS",
        footer: props => props.column.id,
        enableColumnFilter: false,
        enableSorting: false,
      }


    ],
    []
  )




const getWorkOrders = async () => {

    await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-archived-work-orders", {
      start_date: woSearch?.start_date,
      end_date: woSearch?.end_date,
    }, {
      withCredentials: true
    })
      .then(function (response) {

        if (response?.data?.status) {
          setData(response?.data?.work_orders);
        } else {
          Swal.fire({ icon: "error", title: "Pending Admin Action Work Order Failed to Load", text: response?.data?.message });
        }

      })
      .catch(function (error) {

        if (error.status == 403) {

          Swal.fire({ icon: "error", title: "Session Expired", text: error.message });
          navigate("/login");

        }
        else {

          Swal.fire({ icon: "error", title: "Archived Work Order Failed", text: error.message });

        }

      });

  }

  const clearDateFilter = () => {
    setWoSearch(null);

    getWorkOrders();
  }



  const copyWorkOrder = async (work_order_id) => {

    await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/copy-work-order", {
      work_order_id: work_order_id
    }, {
      withCredentials: true
    })
      .then(function (response) {

        if (response?.data?.status) {

          getWorkOrders();
          Swal.fire({ icon: "success", title: "Work order copied successfully. " });


        } else {

          Swal.fire({ icon: "error", title: "Unable to copy work order " });

        }

      })
      .catch(function (error) {

        catchError(error, navigate)

      });


  }

  const reOpenWorkOrder = async (work_order_id) => {

    await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/re-open-work-order", {
      work_order_id: work_order_id
    }, {
      withCredentials: true
    })
      .then(function (response) {

        if (response?.data?.status) {

          getWorkOrders();

        } else {

          Swal.fire({ icon: "error", title: "Unable to reopen work order" });

        }

      })
      .catch(function (error) {

        catchError(error, navigate)

      });


  }

  useEffect(() => {

    getWorkOrders();

  }, []);

  return (
    <>


      <div className="row py-2 start-0 bg-light">

        <div className="col-md-12 col-sm-12 mx-auto text-center">
          <div className="container-fluid z-2  ">

            <span className="btn btn-warning rounded-0 me-1">
              <NavLink className="nav-link" smooth to="/admin/work-orders-active">
                ACTIVE
              </NavLink>
            </span>
            <span className="btn btn-warning rounded-0 me-1">
              <NavLink className="nav-link" smooth to="/admin/work-orders-invoice-needed">
                INVOICE NEEDED
              </NavLink>
            </span>
            <span className="btn btn-warning rounded-0  me-1 ">
              <NavLink className="nav-link" smooth to="/admin/work-orders-records-obtained">
                RECORDS OBTAINED
              </NavLink>
            </span>

            <span className="btn btn-warning rounded-0  me-1 ">
              <NavLink className="nav-link" smooth to="/admin/work-orders-closed">
                CLOSED
              </NavLink>
            </span>

            <span className="btn btn-success rounded-0  me-1 ">
              <NavLink className="nav-link" smooth to="/admin/work-orders-archived">
                ARCHIVED
              </NavLink>
            </span>

            <span className="btn btn-warning rounded-0  me-1 ">
              <NavLink className="nav-link" smooth to="/admin/work-orders-canceled">
                CANCELED
              </NavLink>
            </span>

            <span className="btn btn-warning rounded-0 me-1 ">
              <NavLink className="nav-link" smooth to="/admin/work-orders-incomplete">
                INCOMPLETE
              </NavLink>
            </span>
            <span className="btn btn-warning rounded-0  ">
                          <NavLink className="nav-link" smooth to="/admin/work-orders-missing">
                            MISSING
                          </NavLink>
                        </span>
          </div>
        </div>
      </div>


      <div className="row py-4 start-0  mx-auto ">


        

        <div className="col-md-6 col-sm-12  ">
          <h3 className="text-dark my-0">ARCHIVED WORK ORDERS {(!woSearch?.start_date && !woSearch?.end_date) && "(500 MOST RECENT)"}</h3>
        </div>

        <div className="col-md-6 col-sm-12 ps-3 text-end">

          <span className="btn btn-primary rounded-0 me-1">
            <NavLink className="nav-link" smooth to="/admin/work-orders-new">
              NEW
            </NavLink>
          </span>
          <span className="btn btn-danger rounded-0  me-1 ">
            <NavLink className="nav-link" smooth to="/admin/work-orders-search">
              SEARCH
            </NavLink>
          </span>

        </div>

      </div>




       <div className="card card-form card-primary  pb-2 mb-3">
                <div className="card-body">
                    <form className="form-horizontal form-thick mb-2"  >

                        <div className="row px-3 gx-3">

                            <div className="col-xl-2 col-lg-2 col-sm-2 col-2 my-1">
                                <label htmlFor="invoice_date_range">START DATE</label>



 <DatePicker name="start_date" id="start_date" type="text"
                                    className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selectsStart
                                    isClearable={true}
                                    selected={woSearch?.start_date}
                                    onChange={(e) => {

                                        var dt = new Date(e);

                                        const year = dt.getFullYear();
                                        const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                        const day = dt.getDate().toString().padStart(2, "0");

                                        const formatted_date = month + '/' + day + '/' + year

                                        setWoSearch({ ...woSearch, start_date: formatted_date })

                                    }
                                    }

                                />

  </div>

  <div className="col-xl-2 col-lg-2 col-sm-2 col-2 my-1">
    <label className="form-label mb-0">End Date</label>
    <DatePicker name="end_date" id="end_date" type="text"
                                       className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                                       showYearDropdown
                                       dropdownMode="select"
                                       selectsEnd
                                       isClearable={true}
                                       selected={woSearch?.end_date}
                                       onChange={(e) => {
                                           var dt = new Date(e);
   
                                           const year = dt.getFullYear();
                                           const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                           const day = dt.getDate().toString().padStart(2, "0");
   
                                           const formatted_date = month + '/' + day + '/' + year
   
                                           setWoSearch({ ...woSearch, end_date: formatted_date })
   
                                       }
                                       }
                                   />
  </div>

  <div className="col-xl-2 col-lg-2 col-sm-2 col-2 d-flex align-items-end mb-1">
  <button onClick={() => getWorkOrders()} className="btn btn-md btn-success me-1" type="button">FILTER</button>
  <button onClick={() => clearDateFilter()} className="btn btn-md btn-warning" type="button">CLEAR</button>
</div>

<div className="col-xl-2 col-lg-2 col-sm-2 col-2 d-flex align-items-end mb-1">
  <span className="fw-bold">{data?.length || 0} Records</span>
</div>

</div>


</form>
</div>
</div>  

      {data &&

        <div className="card border-4 border-dark rounded-1 card-success mb-4" >

          <div className="card-body p-0" >

            <CustomTable columns={columns} data={data} />

          </div>
        </div>


      }
    </>

  );
};

export default Archived;